<template>
  <div id="home">
    <section class="blocks">
      <Block></Block>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import Block from '@/components/Block.vue'

export default {
  name: 'home',
  components: {
    Block
  }
}
// lock screen when reached block
// notify block to interact with user scroll
</script>

<style lang="scss">
#home {

  .hero {
    height: 100vh;
    max-height: 1000px;
  }

  .blocks {
    height: 100vh;
    max-height: 1000px;
  }
}
</style>
